import axios from "axios";

export type CachedToken = {
  token: string;
  createdAt: number;
};

export const TOKEN_CACHE_KEY = "sToken";
export const TOKEN_TTL_MS = 5 * 60 * 1000;

const INIT_HEADERS = {
  Accept: "application/json",
  "Content-Type": "application/json",
  tipo: "2",
};

export const readCachedToken = (): CachedToken | null => {
  try {
    const raw = sessionStorage.getItem(TOKEN_CACHE_KEY);

    if (!raw) return null;

    const parsed = JSON.parse(raw) as CachedToken;

    if (!parsed?.token || !parsed?.createdAt) {
      return null;
    }

    return parsed;
  } catch (error) {
    console.error("Erro ao ler token em cache:", error);
    return null;
  }
};

export const writeCachedToken = (token: string): void => {
  const payload: CachedToken = {
    token,
    createdAt: Date.now(),
  };

  sessionStorage.setItem(TOKEN_CACHE_KEY, JSON.stringify(payload));
};

export const clearCachedToken = (): void => {
  sessionStorage.removeItem(TOKEN_CACHE_KEY);
};

export const isTokenValid = (cachedToken: CachedToken | null): boolean => {
  if (!cachedToken) return false;

  return Date.now() - cachedToken.createdAt < TOKEN_TTL_MS;
};

export async function getToken(): Promise<string | null> {
  try {
    const cachedToken = readCachedToken();

    if (isTokenValid(cachedToken)) {
      return cachedToken!.token;
    }

    const response = await axios.get(`${import.meta.env.VITE_INIT}`, {
      headers: INIT_HEADERS,
    });

    const token = response?.data?.access_token ?? null;

    if (token) {
      writeCachedToken(token);
    }

    return token;
  } catch (error) {
    console.error("Erro ao obter token:", error);
    return null;
  }
}